import { ApiStepperItem, STEP_FROM_NUMBER_AOW, StepKeyAOW, StepStateAOW } from './acquire-onboarding-wizard-stepper';

export function normalizeFromApi(items: ApiStepperItem[]): StepStateAOW[] {
    if (!Array.isArray(items)) return [];

    return items
        .map(it => {
            const stepNum = Number(it.step);
            const key: StepKeyAOW | undefined = STEP_FROM_NUMBER_AOW[stepNum];

            // Skip steps that no longer exist in our mapping
            if (!key) return null;

            return {
                step: key,
                status: it.status ?? 'pending',
                updatedAt: it.updatedAt ?? null,
                updatedBy: null,
            };
        })
        .filter((s): s is StepStateAOW => s !== null);
}
